import { useEffect } from 'react'
import { useStore } from '../../../models'
import { ModalContentConfig } from '../../../components/ANewDesign/ModalContent/Content'
import { useJoinCall } from './useJoinCall'
import { Platform } from 'react-native'

export const useShowLive = (handleVideo: () => void, onModalClose: () => void, modalConfig?: ModalContentConfig) => {
  const {
    game: {
      seatedObserver,
      myPlayer,
      landedGameScreenForFirstTime,
      setLandedGameScreenForFirstTime,
      isMyPlayerObserver,
      isWalkthrough,
      isPrivateGame,
      isCommunityGame
    },
    share: { isShareOpen }
  } = useStore()

  const { onJoinWithAvOff } = useJoinCall({})

  const isAGameToShowVideo = isPrivateGame && !isCommunityGame && !isWalkthrough

  const amISeatedObserver = seatedObserver && seatedObserver?.id === myPlayer?.id
  const showLiveVideo =
    isAGameToShowVideo &&
    landedGameScreenForFirstTime &&
    myPlayer &&
    (!isMyPlayerObserver || amISeatedObserver) &&
    !isShareOpen

  const shouldAutoJoin =
    isAGameToShowVideo &&
    landedGameScreenForFirstTime &&
    myPlayer &&
    isMyPlayerObserver &&
    !amISeatedObserver &&
    !isShareOpen

  useEffect(() => {
    if (showLiveVideo) {
      setLandedGameScreenForFirstTime(false)
      handleVideo()
    }
  }, [showLiveVideo, setLandedGameScreenForFirstTime, handleVideo])

  useEffect(() => {
    if (shouldAutoJoin) {
      setLandedGameScreenForFirstTime(false)
      onJoinWithAvOff()
    }
  }, [showLiveVideo, shouldAutoJoin, setLandedGameScreenForFirstTime, handleVideo, onJoinWithAvOff])
}
